export default "__VITE_ASSET__C4H0_X10__"